<template>
  <div id="login">
    <div id="logo">
      <a href="https://www.bigvisiontech.com/" target="_blank"
        ><img src="../assets/images/logo.png" alt=""
      /></a>
    </div>
    <div id="login_box">
      <div class="login">
        <div class="login_left completeInfo_left">
          <div class="login_l_title">
            <span class="active">账户安全中心</span>
          </div>
          <div class="completeInfo_main">
            <div class="completeInfo_m_account">
              <div class="accountSecurity_li clearFix">
                <span class="accountSecurity_li_name fl_l">账号：</span>
                <span class="accountSecurity_li_content fl_l">{{
                  userInfo.username
                }}</span>
                <el-button
                  class="accountSecurity_li_btn fl_r"
                  type="primary"
                  @click="modifyPwd()"
                  >修改密码</el-button
                >
                <!-- <el-button class="accountSecurity_li_btn fl_r" type="primary" @click="centerDialogVisible = true">解绑账号</el-button> -->
              </div>
              <div class="accountSecurity_li clearFix">
                <span class="accountSecurity_li_name fl_l">手机号：</span>
                <span class="accountSecurity_li_content fl_l">{{
                  userInfo.mobile
                }}</span>
                <el-button
                  class="accountSecurity_li_btn fl_r"
                  type="primary"
                  v-if="userInfo.mobile == false"
                  @click="goCompleteInfo()"
                  >绑定</el-button
                >
                <!-- <el-button class="accountSecurity_li_btn fl_r" type="primary" disabled v-if="userInfo.mobile" @click="centerDialogVisible2 = true">解绑</el-button>
                                <el-button class="accountSecurity_li_btn fl_r" type="primary" v-else @click="goCompleteInfo()">绑定</el-button> -->
              </div>
              <div class="accountSecurity_li bor_none clearFix">
                <span class="accountSecurity_li_name fl_l">姓名：</span>
                <span class="accountSecurity_li_content fl_l">{{
                  userInfo.name
                }}</span>
                <el-button
                  class="accountSecurity_li_btn fl_r"
                  type="primary"
                  @click="modifyname()"
                  >修改姓名</el-button
                >
              </div>
              <div class="accountSecurity_li clearFix" v-if="!browser_wx">
                <span class="accountSecurity_li_name fl_l">微信头像:</span>
                <div class="fl_l">
                  <img :src="userInfo.headimgurl" alt="" />
                </div>
                <el-button
                  class="accountSecurity_li_btn fl_r"
                  type="primary"
                  v-if="userInfo.headimgurl"
                  @click="centerDialogVisible3 = true"
                  >解绑</el-button
                >
                <el-button
                  class="accountSecurity_li_btn fl_r"
                  type="primary"
                  v-else
                  @click="goCompleteInfo()"
                  >绑定</el-button
                >
              </div>
              <div class="accountSecurity_li clearFix" v-if="browser_wx">
                <span class="accountSecurity_li_name fl_l">微信头像:</span>
                <div class="fl_l">
                  <img :src="userInfo.headimgurl" alt="" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 修改密码 -->
    <el-dialog
      id="modifyNumber"
      title="账号 · 修改密码"
      :visible.sync="centerDialogVisible"
      width="400px"
      center
    >
      <div>
        <div class="login_l_tel mt30 clearFix">
          <div
            class="login_l_t_r w1 fl_r"
            :class="accountOldPwd_errorMsg_show ? 'bor_red' : ''"
          >
            <el-input
              autocomplete="new-password"
              onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false"
              show-password
              placeholder="请输入旧密码"
              maxlength="18"
              v-model="accountOldPwd"
              @focus="accountOldPwd_focus()"
              @blur="accountOldPwd_blur()"
            ></el-input>
            <p
              class="login_err_tips col_red"
              v-if="accountOldPwd_errorMsg_show"
            >
              {{ accountOldPwd_errorMsg }}
            </p>
          </div>
        </div>
        <div class="login_l_tel mt30 clearFix">
          <div
            class="login_l_t_r w1 fl_r"
            :class="accountPwd_errorMsg_show ? 'bor_red' : ''"
          >
            <el-input
              autocomplete="new-password"
              onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false"
              show-password
              placeholder="请输入新密码"
              maxlength="18"
              v-model="accountPwd"
              @focus="accountPwd_focus()"
              @blur="accountPwd_blur()"
            ></el-input>
            <p class="login_err_tips col_red" v-if="accountPwd_errorMsg_show">
              {{ accountPwd_errorMsg }}
            </p>
          </div>
        </div>
        <div class="login_l_tel mt30 clearFix">
          <div
            class="login_l_t_r w1 fl_r"
            :class="accountRePwd_errorMsg_show ? 'bor_red' : ''"
          >
            <el-input
              autocomplete="new-password"
              onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false"
              show-password
              placeholder="请重复新密码"
              maxlength="18"
              v-model="accountRePwd"
              @keyup.enter.native="modifyNumber()"
              @focus="accountRePwd_focus()"
              @blur="accountRePwd_blur()"
            ></el-input>
            <p class="login_err_tips col_red" v-if="accountRePwd_errorMsg_show">
              {{ accountRePwd_errorMsg }}
            </p>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="centerDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="modifyNumber()">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 修改姓名 -->
    <el-dialog
      id="modifyNumber"
      title="修改姓名"
      :visible.sync="centerDialogVisible_name"
      width="400px"
      center
    >
      <div>
        <div class="login_l_tel mt30 clearFix">
          <div
            class="login_l_t_r w1 fl_r"
            :class="name_errorMsg_show ? 'bor_red' : ''"
          >
            <el-input
              autocomplete="name"
              onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false"
              placeholder="请输入姓名"
              maxlength="18"
              v-model="name"
              @focus="name_focus()"
              @blur="name_blur()"
            ></el-input>
            <p class="login_err_tips col_red" v-if="name_errorMsg_show">
              {{ name_errorMsg }}
            </p>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="centerDialogVisible_name = false">取 消</el-button>
        <el-button type="primary" @click="api_modifyLoginAccount()"
          >确 定</el-button
        >
      </span>
    </el-dialog>

    <!-- 手机号-解除绑定 -->
    <el-dialog
      id="sureunbindMobile"
      title="联系方式 · 解除绑定"
      :visible.sync="centerDialogVisible2"
      width="400px"
      center
    >
      <div style="text-align:center">
        是否解除绑定 <b>{{ userInfo.mobile }}</b> 该手机号？
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="centerDialogVisible2 = false">取 消</el-button>
        <el-button type="primary" @click="sureunbindMobile">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 微信号-解除绑定 -->
    <el-dialog
      id="sureunbindWechat"
      title="微信账号 · 解除绑定"
      :visible.sync="centerDialogVisible3"
      width="400px"
      center
    >
      <div style="text-align:center">
        是否解除绑定 <b>{{ userInfo.nickname }}</b> 该微信号？
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="centerDialogVisible3 = false">取 消</el-button>
        <el-button type="primary" @click="sureunbindWechat">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { _debounce } from '@/js/debounce'
import {
  getAccountInfo,
  modifyPassword,
  modifyLoginAccount,
  unbindMobile,
  unbindWxAccount,
  sendModifyMobileSmsVerifyCode,
  logout
} from '../api/api'
import {
  getUrlSearch,
  setCodeToHeaders,
  isEmpty,
  isMobileNum,
  notLessThanLength,
  isValidPassword
} from '@/js/common'
export default {
  name: 'AccountSecurity',
  data() {
    return {
      userInfo: {
        id: '',
        username: '',
        mobile: '',
        name: '',
        headimgurl: '',
        remark: '',
        name: ''
      },
      centerDialogVisible: false,
      centerDialogVisible2: false,
      centerDialogVisible3: false,
      accountOldPwd: '',
      accountPwd: '',
      accountRePwd: '',
      mobile: '',
      code: '',
      accountOldPwd_errorMsg_show: false,
      accountOldPwd_errorMsg: '',
      accountPwd_errorMsg_show: false,
      accountPwd_errorMsg: '',
      accountRePwd_errorMsg_show: false,
      accountRePwd_errorMsg: '',
      mobile_errorMsg_show: false,
      mobile_errorMsg: '',
      code_errorMsg_show: false,
      code_errorMsg: '',
      browser_wx: true,
      centerDialogVisible_name: false,
      name: '',
      name_errorMsg_show: false,
      name_errorMsg: ''
    }
  },
  created() {
    // 获取地址栏的code值并存入headers中
    setCodeToHeaders(getUrlSearch('code'))
    this.code = getUrlSearch('code')

    this.api_getAccountInfo()

    this.browser_wx = this.isWeChat()
    console.log('browser_wx: ', this.browser_wx)
  },
  methods: {
    modifyPwd() {
      console.log('modifyPwd')
      this.clearAll()
      this.centerDialogVisible = true
    },
    modifyname() {
      this.clearAll()
      this.centerDialogVisible_name = true
    },
    // 接口调用：获取详情信息
    api_getAccountInfo() {
      getAccountInfo().then((res) => {
        if (res) {
          this.userInfo = res
        } else {
          this.$router.push('/')
        }
        // this.userInfo = res
      })
    },
    modifyNumber: _debounce(function() {
      let params = {
        oldPassword: this.accountOldPwd,
        password: this.accountPwd
      }
      if (
        this.accountOldPwd_blur() &&
        this.accountPwd_blur() &&
        this.accountRePwd_blur()
      ) {
        this.centerDialogVisible = false
        modifyPassword(params).then((res) => {
          console.log(res)
          if (res) {
            this.$message.success('修改密码成功')
            logout().then((res) => {
              this.$router.push('/login')
            })
          } else {
            this.$message.error('修改密码失败')
          }
        })
      }
    }),
    api_modifyLoginAccount: _debounce(function() {
      let params = {
        name: this.name
      }
      if (this.name_blur()) {
        this.centerDialogVisible_name = false
        modifyLoginAccount(params).then((res) => {
          console.log(res)
          if (res) {
            this.$message.success('修改姓名成功')
            this.api_getAccountInfo()
          } else {
            this.$message.error('修改姓名失败')
          }
        })
      }
    }),
    name_focus() {
      this.name_errorMsg_show = false
      this.name_errorMsg = ''
    },
    name_blur() {
      if (isEmpty(this.name)) {
        this.name_errorMsg_show = true
        this.aname_errorMsg = '姓名不为空'
        return false
      } else {
        this.name_errorMsg_show = false
        this.name_errorMsg = ''
        return true
      }
    },
    // 手机号 - 解绑
    async sureunbindMobile() {
      await unbindMobile().then((res) => {
        this.centerDialogVisible2 = false
        if (res) {
          this.$message.success('解绑成功')
          this.api_getAccountInfo()
        } else {
          this.$message.error('解绑失败')
        }
      })
    },
    // 绑定 - 跳转至完善信息页面绑定
    goCompleteInfo() {
      if (this.code) {
        this.$router.push({
          path: '/completeInfo',
          query: { code: this.code, formPath: 'acc' }
        })
      } else {
        this.$router.push({ path: '/completeInfo', query: { formPath: 'acc' } })
      }
    },
    // 微信号 - 解绑
    async sureunbindWechat() {
      console.log('sureunbindWechat')
      await unbindWxAccount().then((res) => {
        console.log(res)
        this.centerDialogVisible3 = false
        if (res) {
          this.$message.success('解绑成功')
          this.api_getAccountInfo()
        } else {
          this.$message.error('解绑失败')
        }
      })
    },
    async getverifycode() {
      await sendModifyMobileSmsVerifyCode(this.mobile)
    },
    accountOldPwd_focus() {
      this.accountOldPwd_errorMsg_show = false
      this.accountOldPwd_errorMsg = ''
    },
    accountOldPwd_blur() {
      if (isEmpty(this.accountOldPwd)) {
        this.accountOldPwd_errorMsg_show = true
        this.accountOldPwd_errorMsg = '旧密码不为空'
        return false
      } else {
        this.accountOldPwd_errorMsg_show = false
        this.accountOldPwd_errorMsg = ''
        return true
      }
    },
    accountPwd_focus() {
      this.accountPwd_errorMsg_show = false
      this.accountPwd_errorMsg = ''
    },
    accountPwd_blur() {
      if (isEmpty(this.accountPwd)) {
        this.accountPwd_errorMsg_show = true
        this.accountPwd_errorMsg = '新密码不为空'
        return false
      } else {
        if (isValidPassword(this.accountPwd)) {
          this.accountPwd_errorMsg_show = true
          this.accountPwd_errorMsg = '密码需为8-16位字母和数字组合'
          return false
        } else {
          this.accountPwd_errorMsg_show = false
          this.accountPwd_errorMsg = ''
          return true
        }
      }
    },
    accountRePwd_focus() {
      this.accountRePwd_errorMsg_show = false
      this.accountRePwd_errorMsg = ''
    },
    accountRePwd_blur() {
      if (isEmpty(this.accountRePwd)) {
        this.accountRePwd_errorMsg_show = true
        this.accountRePwd_errorMsg = '重复密码不为空'
        return false
      } else {
        if (this.accountRePwd != this.accountPwd) {
          this.accountRePwd_errorMsg_show = true
          this.accountRePwd_errorMsg = '两次密码不一致'
          return false
        } else {
          this.accountRePwd_errorMsg_show = false
          this.accountRePwd_errorMsg = ''
          return true
        }
      }
    },
    mobile_blur() {
      if (isEmpty(this.mobile)) {
        this.mobile_errorMsg_show = true
        this.mobile_errorMsg = '重复密码不为空'
      } else {
        this.mobile_errorMsg_show = false
        this.mobile_errorMsg = ''
      }
    },
    code_blur() {
      if (isEmpty(this.code)) {
        this.code_errorMsg_show = true
        this.code_errorMsg = '重复密码不为空'
      } else {
        this.code_errorMsg_show = false
        this.code_errorMsg = ''
      }
    },
    clearAll() {
      this.accountOldPwd = ''
      this.accountPwd = ''
      this.accountRePwd = ''
      this.mobile = ''
      this.code = ''
      this.name = ''
      this.accountOldPwd_errorMsg_show = false
      this.accountOldPwd_errorMsg = ''
      this.accountPwd_errorMsg_show = false
      ;(this.accountPwd_errorMsg = ''),
        (this.accountRePwd_errorMsg_show = false)
      this.accountRePwd_errorMsg = ''
      this.name_errorMsg_show = false
      this.name_errorMsg = ''
    },
    isWeChat() {
      //window.navigator.userAgent属性包含了浏览器类型、版本、操作系统类型、浏览器引擎类型等信息，这个属性可以用来判断浏览器类型
      var ua = window.navigator.userAgent.toLowerCase()
      //通过正则表达式匹配ua中是否含有MicroMessenger字符串
      if (ua.match(/MicroMessenger/i) == 'micromessenger') {
        return true
      } else {
        return false
      }
    }
  }
}
</script>
<style scoped>
@import url('../assets/css/base.css');
@import url('../assets/css/login.css');
@import url('../assets/css/accountSecurity.css');
</style>
